// src/auth/roles.js
export const ROLES = {
  ADMIN: "ADMIN",
  SUPERVISOR: "SUPERVISOR",
  OPERATOR: "OPERATOR",
};

export const ROLE_HOME = {
  [ROLES.ADMIN]: "/admin",
  [ROLES.SUPERVISOR]: "/home",
  [ROLES.OPERATOR]: "/dashboardlock", // ajusta si quieres otra
};
